import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const ProductCustomizationPanel = Box.withConfig({
  height: 'full',
  width: 'full',
  alignSelf: 'center',
});

export const ModifierGroupContainer = Box.withConfig({
  width: 'full',
  margin: 0,
  padding: 0,
});

export const ProductSelectedItemCustomizationContainer = Box.withConfig({
  width: 'full',
  paddingX: '$2',
  paddingY: '$4',
  backgroundColor: primitive.$blackOpacity4,
  marginY: '$4',
  borderRadius: primitive.$borderRadius,
});
